import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";

export default function useCategoryMutations() {
  const { get, post, put, del, patch } = useApiHelper();
  const queryClient = useQueryClient();

  const bulkUpdateDefaultCategories = useMutation(
    (body: any) => post(`/part/categories/defaults/bulk`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]);
        queryClient.invalidateQueries(["categories"]);
      },
    }
  );

  const bulkPatchDefaultCategories = useMutation(
    (body: any) => patch(`/part/categories/defaults/bulk`, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["parts"]); //this does default categories too
        queryClient.invalidateQueries(["categories"]);
      },
    }
  );

  return {
    bulkUpdateDefaultCategories,
    bulkPatchDefaultCategories
  };
}
